import { z } from "zod";

// Enums
export enum InfluencerCategory {
  FOOD = "food",
  WELL_NESS = "wellness",
  AdventureTravel = "adventure",
  RoadTrip = "road",
  Backpack = "backpack",
}

export enum BusinessType {
  REAL = "real",
  LEGAL = "legal",
}

export enum SocialMedia {
	INSTAGRAM = 'instagram',
	X = 'x',
	TIK_TOK = 'tiktok',
	YOUTUBE = 'youtube',
	TELEGRAM = 'telegram',
	SNAPCHAT = 'snapchat',
	FACEBOOK = 'facebook',
}


export const signInFormSchema = z.object({
  firstName: z.string().nonempty('First name is required'),
  lastName: z.string().nonempty('Last name is required'),
  homeLocation: z.string().nonempty('Location  is required'),
  bio: z.string().nonempty('Biography is required'),
  category: z
    .array(z.string())
    .refine((categories) => categories.length > 0, {
      message: 'At least one category must be provided',
    }),
  workLocations: z.array(z.string().min(2, 'Each location must be at least 2 characters long')),
  blog: z
  .object({
    title: z.string().nonempty('Title is required'),
    url: z.string().url('Invalid URL'),
    rssFeed: z.string().url('Invalid URL').optional(),
  })
  .optional(),
  social: z
    .array(
      z.object({
        type: z.string(),
        id: z.string().min(1, 'Social ID was not provided'),
        followersCount: z.number().nonnegative(),
      })
    )
    .refine((socials) => socials.length > 0, {
      message: 'At least one social must be provided',
    }),
});

